import React, { useEffect, useState } from 'react';
import { trackEvent } from '../utils/metaPixel';
export function ExitIntentPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [hasShown, setHasShown] = useState(false);
  useEffect(() => {
    const handleMouseLeave = (e: MouseEvent) => {
      // Only trigger if mouse leaves from the top of the viewport
      if (e.clientY <= 0 && !hasShown) {
        setIsVisible(true);
        setHasShown(true);
      }
    };
    // Add event listener after a short delay to avoid triggering on initial page load
    const timer = setTimeout(() => {
      document.addEventListener('mouseleave', handleMouseLeave);
    }, 3000);
    return () => {
      clearTimeout(timer);
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [hasShown]);
  const handleClose = () => {
    setIsVisible(false);
  };
  const handleCTA = () => {
    trackEvent('InitiateCheckout', {
      content_name: 'Exit Intent - Pack Base',
      value: 13.99,
      currency: 'EUR'
    });
  };
  if (!isVisible) return null;
  return <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-in fade-in duration-300" data-id="element-144">
      <div className="bg-gradient-card border-2 border-brand-gold rounded-3xl p-8 max-w-lg w-full shadow-gold-glow-lg relative animate-in zoom-in duration-300" data-id="element-145">
        <button onClick={handleClose} className="absolute top-4 right-4 text-brand-textMuted hover:text-brand-text text-2xl font-bold transition-colors" aria-label="Cerrar" data-id="element-146">
          ✖️
        </button>

        <div className="text-center" data-id="element-147">
          <div className="text-5xl mb-4" data-id="element-148">⏳</div>
          <h2 className="text-2xl md:text-3xl font-bold text-brand-title mb-4" data-id="element-149">
            Antes de irte...
          </h2>
          <p className="text-xl text-brand-subtitle font-semibold mb-6" data-id="element-150">
            ¿Tienes clase esta semana sin planificar?
          </p>
          <p className="text-lg text-brand-text mb-8 leading-relaxed" data-id="element-151">
            Llévate el Manual del Instructor de Bachata con todos los bonos
            gratis.
          </p>

          <div className="bg-brand-card/50 border border-brand-borderGlow/30 rounded-xl p-4 mb-6" data-id="element-152">
            <p className="text-brand-gold font-bold text-lg" data-id="element-153">
              Solo 13,99€ · Garantía 7 días · Acceso en 2 minutos
            </p>
          </div>

          <div className="space-y-3" data-id="element-154">
            <a href="https://digipromarket.com/cart/56520042512710:1" target="_blank" rel="noopener noreferrer" onClick={handleCTA} className="font-heading w-full bg-gradient-gold hover:opacity-90 text-brand-bg font-bold text-xl py-4 px-8 rounded-2xl transition-all hover:scale-[1.02] active:scale-[0.98] text-center block shadow-gold-glow tracking-wide" data-id="element-155">
              🚀 SÍ, QUIERO EL MANUAL
            </a>

            <button onClick={handleClose} className="w-full text-brand-textMuted hover:text-brand-text text-sm transition-colors underline" data-id="element-156">
              No gracias, prefiero seguir improvisando
            </button>
          </div>
        </div>
      </div>
    </div>;
}